var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3056 1H22.1389C21.7569 1 21.4444 1.30375 21.4444 1.675V27.325C21.4444 27.6963 21.7569 28 22.1389 28H26.3056C26.6875 28 27 27.6963 27 27.325V1.675C27 1.30375 26.6875 1 26.3056 1Z",
    fill: "#EEA111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.86111 1H2.69444C2.3125 1 2 1.30375 2 1.675V27.325C2 27.6963 2.3125 28 2.69444 28H6.86111C7.24305 28 7.55556 27.6963 7.55556 27.325V1.675C7.55556 1.30375 7.24305 1 6.86111 1Z",
    fill: "#EEA111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.0f0a0afdb00dfd4e06ef8bf87a5601b7.svg";
export { ForwardRef as ReactComponent };